import React from 'react'
import PropTypes from 'prop-types'

const GetStartedPackage = ({ data, title, subtitle }) => {
  const items = data.map((item, i) => (
    <li key={`plan-${i}`} className="plan-before relative mb4 mb5-m mb6-l pl5">
      {item}
    </li>
  ))

  return (
    <div className="flex-grow-1">
      <div className="mb6 tc">
        <h4 className="mv0 f6 lh-title fw7">{title}</h4>
        <p className="f10 mv0">{subtitle}</p>
      </div>

      <ul className="list ma0">{items}</ul>
    </div>
  )
}

GetStartedPackage.propTypes = {
  data: PropTypes.array
}

export default GetStartedPackage



// WEBPACK FOOTER //
// ./src/components/get-started-package/get-started-package-list.js